<div (click)="scrollToTop()" [class.active]="isActive" class="mc-top-btn"></div>
